import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import LoginMobileHero from '../components/LoginMobileHero';

const Forget = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const API_BASE_URL = process.env.REACT_APP_API_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = email.trim();
    if (!trimmed) {
      toast.error('Please enter your email.');
      return;
    }
    if (!API_BASE_URL) {
      toast.error('Missing REACT_APP_API_URL in environment');
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${API_BASE_URL}`, {
        action: 'forgetPassword',
        email: trimmed
      });

      if (response.data?.status === 'success') {
        toast.success(response.data.message || 'Check your email for reset instructions.');
        setEmail('');
      } else {
        toast.error(response.data?.message || 'Request failed. Please try again.');
      }
    } catch (error) {
      console.error('Forget password error:', error);
      if (error.response) {
        toast.error(error.response.data?.message || 'Request failed. Please try again.');
      } else if (error.request) {
        toast.error('Network error. Please check your connection.');
      } else {
        toast.error('An error occurred. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-image-section mobile-image">
        <LoginMobileHero />
      </div>

      {/* Left Panel - Forget Password Form */}
      <div className="login-left-panel">
        <div className="login-content">
          {/* Header Section */}
          <div className="login-header">
            <img src="/Assets/Images/Adukkumadi-Logos.png" alt="Logo" className="login-logo-image" />
          </div>

          {/* Forget Password Form Section */}
          <div className="login-form-section">
            <h1 className="login-title">Forgot Password</h1>
            
            <form onSubmit={handleSubmit} className="login-form">
              {/* Email Input */}
              <div className="input-wrapper">
                <svg className="input-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.5 6.66667L10 11.6667L17.5 6.66667M3.33333 15H16.6667C17.5871 15 18.3333 14.2538 18.3333 13.3333V6.66667C18.3333 5.74619 17.5871 5 16.6667 5H3.33333C2.41286 5 1.66667 5.74619 1.66667 6.66667V13.3333C1.66667 14.2538 2.41286 15 3.33333 15Z" stroke="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <input
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="login-input"
                  required
                />
              </div>

              {/* Submit Button */}
              <button type="submit" className="login-next-btn" disabled={loading}>
                {loading ? "Sending..." : "Submit"}
              </button>
            </form>

            {/* Back to Login Link */}
            <div className="register-link-wrapper" style={{ marginTop: '24px' }}>
              <p className="register-text">
                Remember your password?{' '}
                <a href="/" onClick={(e) => { e.preventDefault(); navigate('/'); }} className="register-link">
                  Back to Login
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Right Panel - Image (Desktop) */}
      <div className="login-right-panel desktop-image">
        <div className="image-wrapper">
          <img src="/Assets/Images/loginpage.png" alt="Adukkumadi" className="login-image" />
        </div>
      </div>

      {/* Footer - Centered across entire page */}
      <div className="login-footer">
        <p className="login-footer-text">Developed by <a href="https://instatenders.in" target="_blank" rel="noopener noreferrer" className="footer-link">instatenders.in</a></p>
      </div>
    </div>
  );
};

export default Forget;
